export const ADDPRODUCT = "product/addproduct";
export const MINUSPRODUCT = "product/minusproduct";
export const PLUSPRODUCT = "product/plusproduct";
export const DELETEPRODUCT = "product/deleteproduct";